import axios from 'axios'
import { Message } from 'element-ui'
import { getToken } from '../_helpers';
import router from '@/router'

// 注意：不在全局设置Content-Type，而是在拦截器中根据请求类型动态设置
// axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8' // 已移除，避免影响文件上传

// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  // baseURL: process.env.VUE_APP_BASE_API,
  baseURL: process.env.VUE_APP_API_BASE_PATH,

  // 超时
  timeout: 100000
})

// request拦截器
service.interceptors.request.use(config => {
  // 是否需要设置 token
  const isToken = (config.headers || {}).isToken === false
  if (getToken() && !isToken) {
    config.headers['Authorization'] = 'Bearer ' + getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
  }
  
  // 智能设置Content-Type，确保不影响其他API调用
  const isFormData = config.data instanceof FormData;
  const hasContentType = config.headers && config.headers['Content-Type'];
  
  if (isFormData) {
    // FormData（文件上传）：删除Content-Type，让浏览器自动设置（包含boundary）
    // 这是关键：浏览器会自动设置 multipart/form-data; boundary=...
    if (hasContentType) {
      delete config.headers['Content-Type'];
    }
  } else {
    // 非FormData请求（正常的增删改查API）
    // 只有在用户没有手动设置Content-Type时，才设置默认值
    if (!hasContentType) {
      // 对于GET请求，通常不需要Content-Type
      if (config.method && config.method.toLowerCase() !== 'get') {
        config.headers['Content-Type'] = 'application/json;charset=utf-8';
      }
    }
    // 如果用户已经手动设置了Content-Type，保持不变（比如 'application/x-www-form-urlencoded'）
  }

  // get请求映射params参数
  if (config.method === 'get' && config.params) {
    let url = config.url + '?'
    for (const propName of Object.keys(config.params)) {
      const value = config.params[propName]
      var part = encodeURIComponent(propName) + '='
      if (value !== null && typeof (value) !== 'undefined') {
        if (typeof value === 'object') {
          for (const key of Object.keys(value)) {
            let params = propName + '[' + key + ']'
            var subPart = encodeURIComponent(params) + '='
            url += subPart + encodeURIComponent(value[key]) + '&'
          }
        } else {
          url += part + encodeURIComponent(value) + '&'
        }
      }
    }
    url = url.slice(0, -1)
    config.params = {}
    config.url = url
  }
  return config
}, error => {
  console.log(error)
  Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
  return res.data

},
  error => {
    console.log('API Request Error:' ,error.config?.url , error.config?.status, error.code, error)
    let { message } = error

    const reqUrl = error.config?.url || ''
    /** 操作日誌列表/導出專用接口：超時與網絡錯誤改由頁面右下角 EmpDownloadStatusToast 提示，避免頂部 Element Message 重複 */
    const isOpLogListApi = /GetLogFormDataList|GetLogUserActionList/i.test(reqUrl)
    const isTransportFail =
      message === 'Network Error' ||
      error.code === 'ECONNABORTED' ||
      (typeof error.message === 'string' && /timeout/i.test(error.message))

    // 增强错误信息，区分文件上传和普通API的错误
    const isFileUpload = error.config?.data instanceof FormData;
    
    if (message == 'Network Error') {
      message = '后端接口连接异常，请检查网络连接或稍后重试'
    } else if (message.includes('timeout') || error.code === 'ECONNABORTED') {
      const timeout = error.config?.timeout || 100000;
      const timeoutSeconds = Math.floor(timeout / 1000);
      if (isFileUpload) {
        message = `文件上传超时（${timeoutSeconds}秒），文件可能过大或网络较慢，请尝试压缩文件后重试`
      } else {
        message = `系统接口请求超时（${timeoutSeconds}秒），请稍后重试`
      }
    } else if (message.includes('Request failed with status code')) {
      message = '系统接口' + message.substr(message.length - 3) + '异常'
    }

    const suppressTopMessage = isOpLogListApi && isTransportFail
    if (!suppressTopMessage) {
      Message({
        message: message,
        type: 'error',
        duration: 3 * 1000
      })
    }
    
    // 未设置状态码则默认成功状态
    var code = 200

    if(error.response){
      code = error.response.status 
    }
   
    // 获取错误信息
    if (code === 401) {
      // auto logout if 401 response returned from api
      // logout();
      // location.reload(true);
      router.replace('/auth/login');
    } else if (code === 500) {
      if (!suppressTopMessage) {
        Message({
          message: message,
          type: 'error'
        })
      }
      return Promise.reject(new Error(message))
    } else if (code !== 200) {
      alert(message)
      return Promise.reject('error')
    }
    return Promise.reject(error)
  }
)

function logout() {
  // remove user from local storage to log user out
  localStorage.removeItem('user');
}

export default service
